import { arrayOf, number, shape, string } from "prop-types";

export const locations = arrayOf(
  shape({
    group: string,
    id: number.isRequired,
    name: string.isRequired
  })
);
